<section class="admin-slots">
  <h1>Consultation slots</h1>

  <!-- Bulk generation -->
  <div class="card">
    <h2>Generate slots</h2>
    <p class="hint">Fills each selected weekday in the date range with back-to-back slots.</p>

    <div class="form-grid">
      <label class="field"><span>From date</span><input type="date" [(ngModel)]="form.fromDate" name="fromDate" /></label>
      <label class="field"><span>To date</span><input type="date" [(ngModel)]="form.toDate" name="toDate" /></label>
      <label class="field"><span>Daily start</span><input type="time" [(ngModel)]="form.dailyStart" name="dailyStart" /></label>
      <label class="field"><span>Daily end</span><input type="time" [(ngModel)]="form.dailyEnd" name="dailyEnd" /></label>
      <label class="field"><span>Slot duration (min)</span><input type="number" min="1" [(ngModel)]="form.slotDurationMinutes" name="duration" /></label>
      <label class="field"><span>Break (min)</span><input type="number" min="0" [(ngModel)]="form.breakMinutes" name="break" /></label>
      <label class="field"><span>Capacity</span><input type="number" min="1" [(ngModel)]="form.capacity" name="capacity" /></label>
    </div>

    <div class="weekdays">
      <span class="lbl">Weekdays</span>
      <label *ngFor="let d of weekdays" class="day" [class.on]="d.selected">
        <input type="checkbox" [(ngModel)]="d.selected" [name]="'wd-' + d.value" /> {{ d.label }}
      </label>
    </div>

    <button class="btn primary" [disabled]="!canGenerate || generating()" (click)="generate()">
      {{ generating() ? 'Generating…' : 'Generate slots' }}
    </button>
  </div>

  <!-- Week calendar -->
  <div class="card">
    <div class="cal-head">
      <h2>Availability</h2>
      <div class="nav">
        <button class="navbtn" (click)="prevWeek()" [disabled]="isLoading()" aria-label="Previous week">‹</button>
        <span class="week-label">{{ weekLabel() }}</span>
        <button class="navbtn" (click)="nextWeek()" [disabled]="isLoading()" aria-label="Next week">›</button>
        <button class="btn ghost today" (click)="today()" [disabled]="isLoading()">Today</button>
      </div>
    </div>

    <div class="legend">
      <span class="dot free"></span> Available
      <span class="dot booked"></span> Booked
      <span class="dot past"></span> Full / past
      <span class="dot off"></span> Inactive
    </div>

    <div class="calendar" [class.loading]="isLoading()">
      <div class="col" *ngFor="let day of days()" [class.today]="day.isToday">
        <div class="col-head">
          <span class="wd">{{ day.label }}</span>
          <span class="dn">{{ day.dayNum }}</span>
        </div>
        <div class="col-body">
          <button *ngFor="let s of day.slots"
                  class="slot"
                  [ngClass]="slotClass(s)"
                  [disabled]="busyId() === s.id"
                  (click)="openSlot(s)">
            {{ s.startAt | date:'HH:mm' }}
            <small *ngIf="s.bookedCount > 0">· {{ s.bookedCount }}/{{ s.capacity }}</small>
          </button>
          <div class="empty" *ngIf="day.slots.length === 0">—</div>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading()" class="state">Loading…</div>
  </div>
</section>
